import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownRole = ({ control, onChange, components, initialValue, label, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, isFilter }) =>
{
    const addAll = (recs) =>
    {
        // Add the desi teacher option to allow un-selection of the attendance officer
        return [ ... recs, { value: 0, label: 'All'} ] ;
    }

    const postProcessor = isFilter ? addAll : undefined ;

    const [ loading, items ] = useListboxFetch( {url: '/users/types', keyFieldName: 'type_id', labelFieldName: 'typeName', postProcessingFn: postProcessor } ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} label={label} components={components} initialValue={initialValue} control={control} onChange={onChange} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownRole;